
















































































































































































import Breadcrumbs from "../widget/AppBreadcrumbs.vue";
import ErrorLog from "../widget/AppErrorLog.vue";
import FullScreen from "../widget/AppFullScreen.vue";
import Localization from "../widget/AppLocalization.vue";
import Notification from "../widget/AppNotification.vue";
import Profile from "../widget/AppProfile.vue";
import InviteUser from "../widget/AppInviteUser.vue";
import EditLocation from "../widget/AppEditLocation.vue";
import AppSaveEditLocation from "../widget/AppSaveEditLocation.vue";
import ButtonCustomer from "../widget/AppButtonEditCustomer.vue";
import AddCustomer from "../widget/AppButtonAddCustomer.vue";
import ButtonCancelAddCustomer from "../widget/AppButtonCancelAddCustomer.vue";
import AppButtonAddTreatment from "../widget/AppButtonAddTreatment.vue";
import AddCancelAddTreament from "../widget/AppButtonAddCancelAddTreament.vue";
import AppButtonExportAddTreament from "../widget/AppButtonExportAddTreament.vue";
import EditCancelTreament from "../widget/AppButtonEditCancelTreament.vue";
import AddInstruction from "../widget/AppAddInstruction.vue";
import AddEmail from "../widget/AppAddEmail.vue";
import AppButtonAddEquipment from "../widget/AppButtonAddEquipment.vue";
import AppButtonExportAddTreatmentRequest from "../widget/AppButtonExportAddTreatmentRequest.vue";
import AppButtonCancelButtonTreamentRequestSubmit from "../widget/AppButtonCancelButtonTreamentRequestSubmit.vue";
import AppButtonAddCancelFailureTracking from "../widget/AppButtonAddCancelFailureTracking.vue";
import AppButtonAddFailureTracking from "../widget/AppButtonAddFailureTracking.vue";
import AppButtonShipment from "../widget/AppButtonShipment.vue";
import AppButtonAddShipment from "../widget/AppButtonAddShipment.vue";
import AppButtonAddCancelShipment from "../widget/AppButtonAddCancelShipment.vue";
import AppButtonSaveCancelShipment from "../widget/AppButtonSaveCancelShipment.vue";
import AppButtonAddLicense from "../widget/AppButtonAddLicense.vue";
import AppButtonCancelSaveRpa from "../widget/AppButtonCancelSaveRpa.vue";
import AppButtonAddRpa from '../widget/AppButtonAddRpa.vue';
import AppButtonCloseEditFailure from '../widget/AppButtonCloseEditFailure.vue';
import Component from "vue-class-component";
import Vue from "vue";
import { logout } from "../../utils/logout";


@Component({
  components: {
    Breadcrumbs,
    ErrorLog,
    FullScreen,
    Localization,
    Notification,
    Profile,
    InviteUser,
    EditLocation,
    AppSaveEditLocation,
    ButtonCustomer,
    AddCustomer,
    ButtonCancelAddCustomer,
    AppButtonAddTreatment,
    AddCancelAddTreament,
    EditCancelTreament,
    AddInstruction,
    AddEmail,
    AppButtonExportAddTreament,
    AppButtonAddEquipment,
    AppButtonExportAddTreatmentRequest,
    AppButtonCancelButtonTreamentRequestSubmit,
    AppButtonAddCancelFailureTracking,
    AppButtonAddFailureTracking,
    AppButtonShipment,
    AppButtonAddShipment,
    AppButtonAddCancelShipment,
    AppButtonSaveCancelShipment,
    AppButtonAddLicense,
    AppButtonCancelSaveRpa,
    AppButtonAddRpa,
    AppButtonCloseEditFailure
  },
})
export default class TheLayoutToolbar extends Vue {

  get navbarShow() {
    return this.$store.getters.navbarShow;
  }

  get user() {
    return this.$store.getters.user;
  }

  onExport() {
    this.$store.commit("EXPORT_VARIABLE");
  }

  onImport() {
    this.$store.commit("IMPORT_VARIABLE");
  }

  async handleLogout() {
    await logout(this.$store, this.$router);
  }

}
